import React, { useState } from "react"
import StepConfirmation, { ConfirmationDialogProps } from "./StepConfirmation"

export interface ConfirmationDialogPropsWithState {
    onClose: (state: any) => void
    closeLabel?: string
    onYes?: (state: any) => void
    yesLabel?: string
    yesDisabled?: boolean | ((state: any) => boolean)
    onNo?: (state: any) => void
    noLabel?: string
    title?: string
    content?: (state: any, setState: React.Dispatch<React.SetStateAction<any>>) => JSX.Element
}

export interface StepConfirmationWithStateProps {
    confirmationDialogs: ConfirmationDialogPropsWithState[]
    finish: (state: any) => void
    cancel: (state: any) => void
    isValid: boolean
}

const StepConfirmationWithState = ({
    confirmationDialogs,
    finish,
    cancel,
    isValid
}: StepConfirmationWithStateProps) => {
    const [contentState, setContentState] = useState<any>()

    const transformedDialogs: ConfirmationDialogProps[] = confirmationDialogs.map(dialog => ({
        onClose: () => dialog.onClose(contentState),
        closeLabel: dialog.closeLabel,
        onYes: dialog.onYes ? () => dialog.onYes!(contentState) : undefined,
        yesLabel: dialog.yesLabel,
        yesDisabled: typeof dialog.yesDisabled === 'function' ? dialog.yesDisabled(contentState) : dialog.yesDisabled,
        onNo: dialog.onNo ? () => dialog.onNo!(contentState) : undefined,
        noLabel: dialog.noLabel,
        title: dialog.title,
        content: dialog.content ? dialog.content(contentState, setContentState) : undefined
    }))

    return (
        <StepConfirmation
            confirmationDialogs={transformedDialogs}
            finish={() => finish(contentState)}
            cancel={() => cancel(contentState)}
            isValid={isValid}
        />
    )
}

export default StepConfirmationWithState 